import { render } from "./selectModalComponent.vue?vue&type=template&id=5294c558&ts=true"
import script from "./selectModalComponent?vue&type=script&lang=ts"
export * from "./selectModalComponent?vue&type=script&lang=ts"

import "./_assets/_select-modal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__